import type { CaseMetadata, MacroStepConnectorSeed } from '@/workflow/_contract/kernel';

export function deriveCaseConnectorSeeds(cases: readonly CaseMetadata[]): MacroStepConnectorSeed[] {
    return cases.map((membership) => {
        const isBranch = membership.slotFamily === 'cases';
        return {
            macroStepKind: isBranch ? 'branch' : 'loop',
            logicalMacroStepKey: `${membership.ownerMacroStepKey}:${membership.slotFamily}:${membership.ownerCaseIndex}`,
            startToolStepKey: isBranch ? membership.whenToolStepKey : membership.whatToolStepKey,
            endToolStepKey: isBranch ? membership.whatToolStepKey : membership.whenToolStepKey,
            startStepIndex: isBranch ? membership.whenStepIndex : membership.whatStepIndex,
            endStepIndex: isBranch ? membership.whatStepIndex : membership.whenStepIndex,
            endRole: isBranch ? 'what' : 'when',
        };
    });
}
